var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_4854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9759 25.7523C21.6495 25.7523 27.0592 20.5291 27.0592 14.0856C27.0592 7.64211 21.6495 2.41895 14.9759 2.41895C8.30229 2.41895 2.89258 7.64211 2.89258 14.0856C2.89258 20.5291 8.30229 25.7523 14.9759 25.7523Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9759 9.41895V18.7523V9.41895ZM10.1426 14.0856H19.8092H10.1426Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9759 9.41895V18.7523M10.1426 14.0856H19.8092",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_4854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.476562 0.0854492H29.4766V28.0854H0.476562V0.0854492Z",
    fill: "url(#paint0_linear_375_4854)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_375_4854",
    x1: 0.476562,
    y1: 14.0854,
    x2: 29.4766,
    y2: 14.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8F68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#487BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2CD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CFFCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientPlusIcon);
export default __webpack_public_path__ + "static/media/gradientPlusIcon.97a0c703f8ca839e701b31970b0e020d.svg";
export { ForwardRef as ReactComponent };